import type { quick as en } from "../en/quick";
import type { Messages } from "../types";

export const quick: Messages<typeof en> = {
  panel: "عرض سريع",
  openFull: "فتح الصفحة كاملة",
  peekHint: "مرّر أو ركّز للمعاينة، واضغط Enter للفتح",
  loading: "جارٍ التحميل…",
  notFound: "هذا العنصر لم يعد موجوداً.",
  close: "إغلاق",
  copyLink: "نسخ الرابط",
  linkCopied: "تم نسخ الرابط",
  preview: "معاينة",
  post: {
    title: "منشور",
    caption: "النص",
    publications: "منشور على",
    open: "فتح المنشور",
    peek: "معاينة المنشور",
    noMedia: "بلا وسائط",
    metrics: "الأداء",
    rules: "القواعد على هذا المنشور",
    noRules: "لا توجد قواعد تنطبق على هذا المنشور.",
    comments_zero: "لا تعليقات",
    comments_one: "تعليق واحد",
    comments_two: "تعليقان",
    comments_few: "{{count}} تعليقات",
    comments_many: "{{count}} تعليقًا",
    comments_other: "{{count}} تعليق",
    viewOnInstagram: "عرض على إنستغرام",
    scheduledFor: "مجدول في {{when}}",
    publishedAgo: "نُشر {{when}}",
  },
  contact: {
    title: "الشخص",
    peek: "معاينة الشخص",
    firstSeen: "أول ظهور {{when}}",
    lastSeen: "آخر نشاط {{when}}",
    tags: "الوسوم",
    noTags: "لا وسوم بعد",
    recent: "آخر النشاطات",
    noActivity: "لا تعليقات أو رسائل بعد.",
    openProfile: "فتح الملف",
    identities: "الحسابات",
  },
  rule: {
    title: "قاعدة",
    summary: "بكلمات بسيطة",
    triggerPhrase: {
      comment_created: "يعلّق أحد",
      message_received: "يرسل أحد رسالة خاصة",
      mention: "يذكرك أحد",
      story_reply: "يرد أحد على قصة",
      postback: "يضغط أحد زرّاً",
    },
    sentence: "عندما {{trigger}} {{scope}} وكان {{condition}}، يقوم ملفك بـ: {{actions}}.",
    onThisPost: "على هذا المنشور",
    onAccount: "على @{{account}}",
    onAllAccounts: "على أي حساب",
    modeAuto: "ملفك ينفّذها فوراً.",
    modeApprove: "ملفك يجهّز المسودة وينتظر موافقتك.",
    modeSuggest: "ملفك يقترح فقط؛ لا يُرسل شيء.",
    enabled: "القاعدة مفعّلة",
    disabled: "القاعدة متوقفة",
    enable: "تفعيل",
    disable: "إيقاف",
    edit: "تعديل سريع",
    name: "الاسم",
    mode: "الوضع",
    priority: "الأولوية",
    perHour: "الحد الأقصى في الساعة",
    template: "نص الرد",
    templateHint: "المتغيرات: {{vars}}",
    save: "حفظ التغييرات",
    saved: "تم حفظ القاعدة",
    discard: "تجاهل",
    simulate: "جرّبها على هذا المنشور",
    simulateAll: "جرّبها على آخر التعليقات",
    simulateHint: "تجربة على آخر تعليقات هذا المنشور. لا يُرسل أي شيء.",
    simulateResult: "{{matched}} من {{total}} تعليق ستطابق",
    noComments: "لا توجد تعليقات على هذا المنشور للتجربة بعد.",
    recentRuns: "آخر التنفيذات على هذا المنشور",
    recentRunsAll: "آخر التنفيذات",
    noRuns: "لا تنفيذات بعد.",
    viewAllRuns: "كل التنفيذات",
    editFull: "تعديل في الصفحة الكاملة",
    stats: "{{matched}} مطابقة · {{executed}} منفّذة · {{pending}} بانتظار (7 أيام)",
    scope: "تنطبق على",
    scopeAll: "كل الحسابات والمنشورات",
    scopeAccount: "كل منشورات @{{account}}",
    scopePost: "هذا المنشور فقط",
  },
  health: {
    attention: "تحتاج انتباهك",
    ok: "سليمة",
    affected: "المنشورات المتأثرة",
    noAffected: "لا منشورات محددة.",
    openRuns: "فتح سجل الأتمتة",
    openApprovals: "مراجعة الموافقات",
    turnOn: "تفعيل",
    issues: {
      paused: "متوقفة: لن تتصرف مع التعليقات أو الرسائل الجديدة.",
      no_matching_posts: "لا يوجد منشور منشور ضمن نطاقها، فلن تعمل أبداً.",
      failing_runs_zero: "تنفيذات فاشلة خلال آخر 7 أيام: {{count}}.",
      failing_runs_one: "تنفيذات فاشلة خلال آخر 7 أيام: {{count}}.",
      failing_runs_two: "تنفيذات فاشلة خلال آخر 7 أيام: {{count}}.",
      failing_runs_few: "تنفيذات فاشلة خلال آخر 7 أيام: {{count}}.",
      failing_runs_many: "تنفيذات فاشلة خلال آخر 7 أيام: {{count}}.",
      failing_runs_other: "تنفيذات فاشلة خلال آخر 7 أيام: {{count}}.",
      approval_backlog_zero: "مسودات بانتظار الموافقة: {{count}}.",
      approval_backlog_one: "مسودات بانتظار الموافقة: {{count}}.",
      approval_backlog_two: "مسودات بانتظار الموافقة: {{count}}.",
      approval_backlog_few: "مسودات بانتظار الموافقة: {{count}}.",
      approval_backlog_many: "مسودات بانتظار الموافقة: {{count}}.",
      approval_backlog_other: "مسودات بانتظار الموافقة: {{count}}.",
      account_disconnected: "حسابها غير متصل؛ أعد ربطه من الإعدادات.",
    },
    matchingPosts_zero: "{{count}} منشور",
    matchingPosts_one: "منشور واحد",
    matchingPosts_two: "منشوران",
    matchingPosts_few: "{{count}} منشورات",
    matchingPosts_many: "{{count}} منشورًا",
    matchingPosts_other: "{{count}} منشور",
    allPosts: "كل المنشورات",
    dms: "الرسائل الخاصة",
  },
  run: {
    title: "تنفيذ",
    peek: "تفاصيل التنفيذ",
    timeline: "المسار الزمني",
    retry: "إعادة المحاولة",
    retrying: "جارٍ إعادة المحاولة…",
    retried: "أُضيفت إعادة المحاولة",
    retryDone: "اكتملت إعادة المحاولة",
    retryFailed: "فشلت إعادة المحاولة",
    retryBulk_zero: "إعادة المحاولة ({{count}})",
    retryBulk_one: "إعادة المحاولة ({{count}})",
    retryBulk_two: "إعادة المحاولة ({{count}})",
    retryBulk_few: "إعادة المحاولة ({{count}})",
    retryBulk_many: "إعادة المحاولة ({{count}})",
    retryBulk_other: "إعادة المحاولة ({{count}})",
    retryBulkDone: "{{queued}} أُضيفت، {{skipped}} تم تخطيها",
    notRetriable: "يمكن إعادة محاولة التنفيذات الفاشلة فقط.",
    error: "ما الذي حدث",
    actionFailed: "فشل الإجراء. قد تساعد إعادة المحاولة.",
    retries_zero: "مرات إعادة المحاولة: {{count}}",
    retries_one: "مرات إعادة المحاولة: {{count}}",
    retries_two: "مرات إعادة المحاولة: {{count}}",
    retries_few: "مرات إعادة المحاولة: {{count}}",
    retries_many: "مرات إعادة المحاولة: {{count}}",
    retries_other: "مرات إعادة المحاولة: {{count}}",
    retryOf: "إعادة محاولة لتنفيذ سابق",
    steps: {
      event: "ما وصل",
      conditions: "فحص الشروط",
      ai: "قراءة الذكاء الاصطناعي",
      approval: "الموافقة",
      action: "ما فعلته منصة ملفك",
      provider: "رد إنستغرام",
      retry: "إعادة المحاولة",
    },
    stepStatus: { ok: "تم", skipped: "تم التخطي", pending: "بانتظار", failed: "فشل", info: "معلومة" },
    trace: "فتح تتبّع الذكاء الاصطناعي",
    idempotencyKey: "مفتاح عدم التكرار",
    openEvent: "فتح في صندوق الوارد",
    filters: {
      title: "التصفية",
      rule: "القاعدة",
      post: "المنشور",
      status: "الحالة",
      action: "الإجراء",
      time: "الوقت",
      anyRule: "أي قاعدة",
      anyPost: "أي منشور",
      anyStatus: "أي حالة",
      anyAction: "أي إجراء",
      anyTime: "أي وقت",
      last24h: "آخر 24 ساعة",
      last7d: "آخر 7 أيام",
      last30d: "آخر 30 يوماً",
      clear: "مسح التصفية",
      selected_zero: "المحدد: {{count}}",
      selected_one: "المحدد: {{count}}",
      selected_two: "المحدد: {{count}}",
      selected_few: "المحدد: {{count}}",
      selected_many: "المحدد: {{count}}",
      selected_other: "المحدد: {{count}}",
      selectRun: "تحديد التنفيذ",
      selectAllFailed: "تحديد الفاشلة",
    },
  },
  approvals: {
    filters: "التصفية",
    post: "المنشور",
    anyPost: "أي منشور",
    account: "الحساب",
    anyAccount: "أي حساب",
    rule: "القاعدة",
    anyRule: "أي قاعدة",
    kind: "النوع",
    anyKind: "أي نوع",
    age: "العمر",
    anyAge: "أي عمر",
    ageNew: "أقل من ساعة",
    ageDay: "1–24 ساعة",
    ageOld: "أكثر من 24 ساعة",
    clear: "مسح",
    searchPosts: "ابحث في المنشورات",
    noPosts: "لا منشورات عليها موافقات معلّقة.",
    rejectSelected_zero: "رفض ({{count}})",
    rejectSelected_one: "رفض ({{count}})",
    rejectSelected_two: "رفض ({{count}})",
    rejectSelected_few: "رفض ({{count}})",
    rejectSelected_many: "رفض ({{count}})",
    rejectSelected_other: "رفض ({{count}})",
    batchRejected_zero: "تم الرفض: {{count}}",
    batchRejected_one: "تم الرفض: {{count}}",
    batchRejected_two: "تم الرفض: {{count}}",
    batchRejected_few: "تم الرفض: {{count}}",
    batchRejected_many: "تم الرفض: {{count}}",
    batchRejected_other: "تم الرفض: {{count}}",
    batchPartial: "{{ok}} تمت، {{failed}} فشلت",
    noMatch: "لا شيء يطابق هذه التصفية.",
    onPost: "على هذا المنشور",
  },
};
